import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRole, children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const isVerified = localStorage.getItem("isVerified");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isVerified !== "true") {
    return <Navigate to="/verify" replace />;
  }

  if (role !== allowedRole) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
